function defaultLayout() {
    return () =>
        import ('@/layouts/default')
}

function commonLayout() {
    return () =>
        import ('@/layouts/CommonLayout')
}

export default [{
    path: '*',
    redirect: {
        path: '/login'
    }
},
    {
        path: '/404',
        name: 'NotFound',
        component: () =>
            import (`@/views/errors/NotFound.vue`)
    },
    {
        path: '/gc-voucher',
        name: 'GenerateVoucher',
        component: () =>
            import (`@/views/GenerateVoucher.vue`)
    },
    {
        path: '/update-gc-voucher',
        name: 'UpdateGenerateVoucher',
        component: () =>
            import (`@/views/UpdateGenerateVoucher.vue`)
    },
    {
        path: '/403',
        name: 'AccessDenied',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/Deny.vue`
                )
    },
    {
        path: '/500',
        name: 'ServerError',
        component: () =>
            import (
                `@/views/errors/Error.vue`
                )
    },

    {
        path: '/login',
        name: 'Login',
        component: () =>
            import (
                `@/views/Login.vue`
                ),
    },

    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () =>
            import (
                `@/views/resetpassword/ForgotPassword.vue`
                ),
    },
    {
        path: '/password/reset',
        name: 'TokenVerification',
        component: () =>
            import (
                `@/views/resetpassword/TokenVerification.vue`
                ),
    },
    {
        path: '/system',
        component: defaultLayout(),
        children: [
            {
                path: '/',
                redirect: {
                    path: '/system/dashboard'
                },
            },
            {
                path: 'settings',
                name: 'Setting',
                component: () =>
                    import (
                        `@/views/Setting.vue`
                        )
            },
            {
                path: 'dashboard',
                component: () =>
                    import (
                        `@/views/Dashboard.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: []
                },
                name: 'Dashboard'
            },
            {
                path: '/change-visa-number',
                name: 'ChangeVisaNumber',
                component: () =>
                    import (`@/views/visa/new_entry/ChangeVisaNumber.vue`),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['alter visa-number']
                },
            },
            {
                path: 'profile',
                component: () =>
                    import (
                        `@/views/Profile.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: []
                },
                name: 'Profile'
            },
            {
                path: '2fa',
                component: () =>
                    import (
                        `@/views/2FA.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: []
                },
                name: '2FA'
            },
            {
                path: 'permission',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: '/',
                        name: 'Permission',
                        component: () =>
                            import (
                                `@/views/acl/Permission.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read permission']
                        }
                    },


                ]
            },
            {
                path: 'role',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Role',
                    component: () =>
                        import (
                            `@/views/acl/Role.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read role']
                    }
                },]
            },
            {
                path: 'permission-types',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'PermissionTypes',
                    component: () =>
                        import (
                            `@/views/acl/PermissionTypes.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read permissions']
                    }
                },]
            },
            {
                path: 'arrival-departure-cancellation',
                component: () =>
                    import (
                        `@/views/visa/ArrivalDepartCancel.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['read arrival-departure-cancellation']
                },
                name: 'ADCancel'
            },
            {
                path: 'deportation',
                component: () =>
                    import (
                        `@/views/Deportation.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['read deportation']
                },
                name: 'Deportation'
            },
            {
                path: 'report',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'overall-report',
                        name: 'OverallReport',
                        component: () =>
                            import (
                                `@/views/report/OverAllReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read revenue-report']
                        }
                    },
                    {
                        path: 'revenue-report',
                        name: 'RevenueReport',
                        component: () =>
                            import (
                                `@/views/report/RevenueReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read revenue-report']
                        }
                    },
                    {
                        path: 'revenue-report-by-officer',
                        name: 'OfficerRevenueReport',
                        component: () =>
                            import (
                                `@/views/report/OfficerRevenueReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read officer-revenue-report']
                        }
                    },
                    {
                        path: 'visa-expired-report',
                        name: 'VisaExpiredReport',
                        component: () =>
                            import (
                                `@/views/report/LateStayReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read late-stay-report']
                        }
                    },
                    {
                        path: 'over-stay-report',
                        name: 'OverStayReport',
                        component: () =>
                            import (
                                `@/views/report/OverStayReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read over-stay-report']
                        }
                    },
                    {
                        path: 'previous-stay-report',
                        name: 'PreviousStayReport',
                        component: () =>
                            import (
                                `@/views/report/PreviousStayReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read previous-stay-report']
                        }
                    },
                    {
                        path: 'updated-previous-stay-report',
                        name: 'UpdatedPreviousStayReport',
                        component: () =>
                            import (
                                `@/views/report/UpdatedPreviousStayReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read previous-stay-report']
                        }
                    },
                    {
                        path: 'trekking-revenue-report',
                        name: 'TrekkingRevenueReport',
                        component: () =>
                            import (
                                `@/views/report/TrekkingRevenueReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekking-revenue-report']
                        }
                    },
                    {
                        path: 'trekkers-report',
                        name: 'TrekkersReport',
                        component: () =>
                            import (
                                `@/views/report/TrekkersReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekkers-report']
                        }
                    },
                    {
                        path: 'black-delist-report',
                        name: 'BlackDelistReport',
                        component: () =>
                            import (
                                `@/views/report/BlackDelistReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read blacklist-delist-report']
                        }
                    },
                    {
                        path: 'ad-report',
                        name: 'ArrivalDepartureReport',
                        component: () =>
                            import (
                                `@/views/report/ArrivalDepartureReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read arrived-report']
                        }
                    },
                    {
                        path: 'manual-entry-report',
                        name: 'ManualEntryReport',
                        component: () =>
                            import (
                                `@/views/report/ManualEntryReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read manual-entry-report']
                        }
                    },
                    {
                        path: 'watchlist-document',
                        name: 'WatchListDocumentReport',
                        component: () =>
                            import (
                                `@/views/report/WatchListDocumentReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read watchlist-document']
                        }
                    },
                    {
                        path: 'offload-report',
                        name: 'OffloadReport',
                        component: () =>
                            import (
                                `@/views/report/OffloadReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read offload-report']
                        }
                    },
                    {
                        path: 'reload-report',
                        name: 'ReloadReport',
                        component: () =>
                            import (
                                `@/views/report/ReloadReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read reload-report']
                        }
                    },
                    {
                        path: 'entry-refuse-report',
                        name: 'EntryRefuseReport',
                        component: () =>
                            import (
                                `@/views/report/EntryRefuseReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read entry-refuse-report']
                        }
                    },
                    {
                        path: 'nepalese-entry-refuse-report',
                        name: 'NepaleseEntryRefuseReport',
                        component: () =>
                            import (
                                `@/views/report/NepaleseEntryRefuseReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read entry-refuse-report']
                        }
                    },
                    {
                        path: 'visa-verified-report',
                        name: 'VisaVerifiedReport',
                        component: () =>
                            import (
                                `@/views/report/VisaVerified.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read verified-visa']
                        }
                    },
                    {
                        path: 'visa-paid-report',
                        name: 'VisaPaidReport',
                        component: () =>
                            import (
                                `@/views/report/VisaPaidReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read paid-visa']
                        }
                    },
                    {
                        path: 'certification-report',
                        name: 'CertificationReport',
                        component: () =>
                            import (
                                `@/views/report/CertificationReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                    {
                        path: 'non-visa-certification-report',
                        name: 'NonVisaCertificationReport',
                        component: () =>
                            import (
                                `@/views/report/NonVisaCertificationReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                    {
                        path: 'local-currency-report',
                        name: 'LocalCurrencyReport',
                        component: () =>
                            import (
                                `@/views/report/LocalCurrencyReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read paid-visa']
                        }
                    },
                    {
                        path: 'special-case-payment',
                        name: 'SCPReport',
                        component: () =>
                            import (
                                `@/views/report/SCPReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read special-case-payment']
                        }
                    },
                    {
                        path: 'mobile-device',
                        name: 'MobileDeviceReport',
                        component: () =>
                            import (
                                `@/views/report/MobileDevice.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read mobile-device-report']
                        }
                    },
                ]
            },
            {
                path: 'appointment',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'appointment-shift',
                        name: 'AppointmentShift',
                        component: () =>
                            import (
                                `@/views/appointment/Shift.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read appointment_shift']
                        },
                    },
                    {
                        path: 'appointment-token',
                        name: 'AppointmentToken',
                        component: () =>
                            import (
                                `@/views/appointment/Token.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read appointment_token']
                        },
                    },
                    {
                        path: 'report',
                        name: 'AppointmentReport',
                        component: () =>
                            import (
                                `@/views/appointment/AppointmentReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read appointment-report']
                        }
                    },
                    {
                        path: 'summary-report',
                        name: 'AppointmentSummary',
                        component: () =>
                            import (
                                `@/views/appointment/AppointmentSummary.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read appointment-report']
                        }
                    },
                ]
            },

            {
                path: 'summary-report',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: 'arrival-departure-by-country',
                    name: 'ADCountryWiseReport',
                    component: () =>
                        import (
                            `@/views/summary-report/ADCountryWiseReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read arrival-departure-summary-report']
                    }
                },
                    {
                        path: 'arrival-departure-by-office',
                        name: 'ADOfficeWiseReport',
                        component: () =>
                            import (
                                `@/views/summary-report/ADOfficeWiseReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read arrival-departure-summary-report']
                        }
                    },
                    {
                        path: 'arrival-departure-by-officer',
                        name: 'ADOfficerWiseReport',
                        component: () =>
                            import (
                                `@/views/summary-report/ADOfficeWiserReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read arrival-departure-summary-report']
                        }
                    },
                    {
                        path: 'nepalese-arrival-departure-by-country',
                        name: 'NepaleseADCountryWiseReport',
                        component: () =>
                            import (
                                `@/views/summary-report/NepaleseADCountryWiseReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read nepalese-arrival-departure-summary-report']
                        }
                    },
                    {
                        path: 'traveller-staying-in-nepal',
                        name: 'TravellerStayingInNepalReport',
                        component: () =>
                            import (
                                `@/views/summary-report/TravellerStayingInNepalReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read traveller-staying-in-nepal-summary-report']
                        }
                    },
                    {
                        path: 'traveller-staying-in-nepal-visa-type-wise',
                        name: 'TravellerStayingInNepalVisaTypeWiseReport',
                        component: () =>
                            import (
                                `@/views/summary-report/TravellerStayingInNepalVisaTypeWiseReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read traveller-staying-in-nepal-summary-report']
                        }
                    },
                    {
                        path: 'issued-visa-by-country',
                        name: 'IssuedVisaCountryWise',
                        component: () =>
                            import (
                                `@/views/summary-report/IssuedVisaCountryWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read issued-visa-summary-report']
                        }
                    },
                    {
                        path: 'valid-issued-visa-by-country',
                        name: 'ValidIssuedVisaCountryWise',
                        component: () =>
                            import (
                                `@/views/summary-report/ValidIssuedVisaCountryWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read valid-issued-visa-summary-report']
                        }
                    },
                    {
                        path: 'issued-visa-by-office',
                        name: 'IssuedVisaOfficeWise',
                        component: () =>
                            import (
                                `@/views/summary-report/IssuedVisaOfficeWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read issued-visa-summary-report']
                        }
                    },
                    {
                        path: 'revenue-by-country',
                        name: 'RevenueCountryWise',
                        component: () =>
                            import (
                                `@/views/summary-report/RevenueCountryWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read revenue-summary-report']
                        }
                    },
                    {
                        path: 'revenue-by-office',
                        name: 'RevenueOfficeWise',
                        component: () =>
                            import (
                                `@/views/summary-report/RevenueOfficeWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read revenue-summary-report']
                        }
                    },
                    {
                        path: 'revenue-by-section',
                        name: 'RevenueSectionWise',
                        component: () =>
                            import (
                                `@/views/summary-report/RevenueSectionWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read revenue-summary-report']
                        }
                    },
                    {
                        path: 'revenue-by-office-type',
                        name: 'RevenueOfficeTypeWise',
                        component: () =>
                            import (
                                `@/views/summary-report/RevenueOfficeTypeWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read revenue-summary-report']
                        }
                    },
                    {
                        path: 'revenue-by-trekking-route',
                        name: 'TrekkingRouteWise',
                        component: () =>
                            import (
                                `@/views/summary-report/TrekkingRouteWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekking-route-wise-summary-report']
                        }
                    },
                    {
                        path: 'revenue-by-trekking-agency',
                        name: 'TrekkingRevenueAgencyWise',
                        component: () =>
                            import (
                                `@/views/summary-report/TrekkingRevenueAgencyWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekking-revenue-agency-wise-summary-report']
                        }
                    },
                    {
                        path: 'revenue-by-trekking-office',
                        name: 'TrekkingRevenueOfficeWise',
                        component: () =>
                            import (
                                `@/views/summary-report/TrekkingRevenueOfficeWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekking-revenue-office-wise-summary-report']
                        }
                    },
                    {
                        path: 'trekkers-country-wise',
                        name: 'TrekkersCountryWise',
                        component: () =>
                            import (
                                `@/views/summary-report/TrekkersCountryWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekkers-country-wise-summary-report']
                        }
                    },
                    {
                        path: 'visa-expired-country-wise',
                        name: 'VisaExpiredCountryWise',
                        component: () =>
                            import (
                                `@/views/summary-report/VisaExpiredCountryWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-expired-country-wise-summary-report']
                        }
                    }, {
                        path: 'visa-expired-visa-type-wise',
                        name: 'VisaExpiredVisaTypeWise',
                        component: () =>
                            import (
                                `@/views/summary-report/VisaExpiredVisaTypeWise.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-expired-visa-type-wise-summary-report']
                        }
                    },
                    {
                        path: 'office-revenue-head',
                        name: 'OfficeRevenueHead',
                        component: () =>
                            import (
                                `@/views/summary-report/OfficeRevenueHeadReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read office-revenue-head-summary-report']
                        }
                    },
                    {
                        path: 'travellers',
                        name: 'TravellerSummary',
                        component: () =>
                            import (
                                `@/views/summary-report/TravellerSummary.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read traveller-summary-report']
                        }
                    },
                    {
                        path: 'departure-purpose',
                        name: 'DeparturePurposeSummary',
                        component: () =>
                            import (
                                `@/views/summary-report/DeparturePurposeSummary.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read departure-purpose-summary-report']
                        }
                    },
                    {
                        path: 'departure-purpose/view/:purpose',
                        name: 'CountryWiseDeparturePurposeViewReport',
                        component: () =>
                            import (
                                `@/views/summary-report/CountryWiseDeparturePurposeViewReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read departure-purpose-summary-report']
                        }
                    },
                    {
                        path: 'multiple-arrival-departure-report',
                        name: 'multipleArrivalDepartureReport',
                        component: () =>
                            import (
                                `@/views/summary-report/MultipleArrivalDepartureSummary.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read departure-purpose-summary-report']
                        }
                    },
                ]
            },
            {
                path: 'daily-report',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'airport-officer-wise',
                        name: 'AirportOfficerWiserReport',
                        component: () =>
                            import (
                                `@/views/daily-report/AirportOfficerWiseReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read airport-officer-wise-daily-report']
                        }
                    }]
            },
            {
                path: 'charts',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'arrival-departure',
                        name: 'ArrivalDepartureChart',
                        component: () =>
                            import (
                                `@/views/charts/ArrivalDepartureChart.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read chart']
                        }
                    },
                    {
                        path: 'entry-refuse-offload',
                        name: 'EntryOffloadChart',
                        component: () =>
                            import (
                                `@/views/charts/EntryRefuseOffloadChart.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read chart']
                        }
                    },
                    {
                        path: 'visas',
                        name: 'VisaChart',
                        component: () =>
                            import (
                                `@/views/charts/VisaChart.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read chart']
                        }
                    },
                    {
                        path: 'revenue',
                        name: 'RevenueChart',
                        component: () =>
                            import (
                                `@/views/charts/RevenueChart.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read chart']
                        }
                    }
                ]
            },
            {
                path: 'issued-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'IssuedVisa',
                    component: () =>
                        import (
                            `@/views/report/IssuedVisaReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read issued-visa']
                    }
                },]
            },
            {
                path: 'valid-issued-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ValidIssuedVisa',
                    component: () =>
                        import (
                            `@/views/report/ValidIssuedVisaReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read valid-issued-visa']
                    }
                },]
            },
            {
                path: 'valid-converted-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ValidConvertedVisa',
                    component: () =>
                        import (
                            `@/views/report/ValidConvertedVisaReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read valid-converted-visa']
                    }
                },]
            },
            {
                path: 'section-wise-issued-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'SectionWiseIssuedVisa',
                    component: () =>
                        import (
                            `@/views/report/SectionWiseIssuedVisaReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read section-wise-issued-visa']
                    }
                },]
            },
            {
                path: 'overstay-processed-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'OverstayProcessedVisa',
                    component: () =>
                        import (
                            `@/views/report/OverstayProcessedVisaReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read overstay-issued-visa']
                    }
                },]
            },
            {
                path: 'entry-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'EntryVisa',
                    component: () =>
                        import (
                            `@/views/report/EntryVisaReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read entry-visa']
                    }
                },]
            },
            {
                path: 'mission-issued-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'MissionIssuedVisa',
                    component: () =>
                        import (
                            `@/views/report/MissionVisaIssued.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read mission-issued-visa']
                    }
                },]
            },
            {
                path: 'rejected-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'RejectedVisa',
                    component: () =>
                        import (
                            `@/views/report/RejectedVisaReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read rejected-visa']
                    }
                }]
            },
            {
                path: 'cancelled-visa',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'CancelledVisa',
                    component: () =>
                        import (
                            `@/views/report/VisaCancelled.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read cancelled-visa']
                    }
                },]
            },
            {
                path: 'hotel-visit-record',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'HotelVisitRecord',
                    component: () =>
                        import (
                            `@/views/hotel/HotelVisitRecord.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read hotel-visit-record']
                    }
                },]
            },
            {
                path: 'setting-logs-change-report',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
            },
            {
                path: 'travellers-history',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: 'scan-report',
                    name: 'TravellersScanReport',
                    component: () =>
                        import (
                            `@/views/traveller/TravellersScanReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read traveller-history']
                    }
                }, {
                    path: 'list',
                    name: 'TravellersHistory',
                    component: () =>
                        import (
                            `@/views/traveller/TravellerList.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read traveller-history']
                    }
                }, {
                    path: 'staying-in-nepal',
                    name: 'TravellersStayingInNepalHistory',
                    component: () =>
                        import (
                            `@/views/traveller/TravellersStayingInNepalList.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read traveller-staying-in-nepal-history-list']
                    }
                }, {
                    path: 'view/:id',
                    name: 'TravellerDetail',
                    props: true,
                    component: () =>
                        import (
                            `@/views/traveller/TravellerDetail.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read traveller-history']
                    }
                },]
            },


            //Logs routes
            {
                path: 'logs',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'setting-changes',
                        name: 'SettingLogsReport',
                        component: () =>
                            import (
                                `@/views/report/SettingLogsReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read settings']
                        }
                    },
                    {
                        path: 'visa-number-change',
                        name: 'VisaNumberChangeLogReport',
                        component: () =>
                            import (
                                `@/views/report/VisaNumberChangeLogReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-number-changelog']
                        }
                    },

                    {
                        path: 'activity',
                        name: 'ActivityLog',
                        component: () =>
                            import (
                                `@/views/logs/ActivityLog.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read activity-log']
                        }
                    },
                    {
                        path: 'message-sent',
                        name: 'SMSLog',
                        component: () =>
                            import (
                                `@/views/logs/MessageSent.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read sms-log']
                        }
                    },


                ]
            },
            {
                path: 'muddha',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'new-entry',
                        name: 'NewMuddha',
                        component: () =>
                            import (
                                `@/views/muddha/New.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['add muddha']
                        }
                    },
                    {
                        path: 'entry-report',
                        name: 'MuddhaEntryReport',
                        component: () =>
                            import (
                                `@/views/muddha/MuddhaEntryReport.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read muddha']
                        }
                    },
                    {
                        path: 'traveller-entry',
                        name: 'NewTravellerEntry',
                        component: () =>
                            import (
                                `@/views/muddha/NewTraveller.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['add traveller']
                        }
                    },
                    {
                        path: 'traveller-confirm',
                        name: 'TravellerConfirm',
                        component: () =>
                            import (
                                `@/views/muddha/TravellerConfirm.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['add traveller']
                        }
                    },
                ]
            },
            {
                path: 'role',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Role',
                    component: () =>
                        import (
                            `@/views/acl/Role.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read role']
                    }
                },]
            },
            {
                path: 'user',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'User',
                    component: () =>
                        import (
                            `@/views/acl/User.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read user']
                    }
                }, {
                    path: 'view/:id',
                    name: 'UserDetail',
                    component: () =>
                        import (
                            `@/views/acl/UserDetail.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read user-history']
                    }
                },]
            },
            {
                path: 'country',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Country',
                    component: () =>
                        import (
                            `@/views/Country.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read country']
                    }
                },]
            },
            {
                path: 'bank',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Bank',
                    component: () =>
                        import (
                            `@/views/Bank.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read bank']
                    }
                },]
            },
            {
                path: 'visa-type',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'VisaType',
                    component: () =>
                        import (
                            `@/views/visa/VisaType.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read visa-type']
                    }
                },]
            },
            {
                path: 'visa-sticker-transaction',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'VisaStickerTransaction',
                    component: () =>
                        import (
                            `@/views/visa/VisaStickerTransaction.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read visa-sticker-transaction']
                    }
                },]
            },
            {
                path: 'tippani',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Tippani',
                    component: () =>
                        import (
                            `@/views/visa/Tippani.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read tippani']
                    }
                },]
            },
            {
                path: 'trekking-tippani',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'TrekkingTippani',
                    component: () =>
                        import (
                            `@/views/trekking/Tippani.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read trekking-tippani']
                    }
                },]
            },
            {
                path: 'documents',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'types',
                        name: 'DocumentType',
                        component: () =>
                            import (
                                `@/views/document/DocumentType.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read document-types']
                        }
                    },
                    {
                        path: 'document-store',
                        name: 'DocumentStore',
                        component: () =>
                            import (
                                `@/views/document/DocumentStore.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read document-store']

                        }
                    },
                    {
                        path: 'recommendation-letter',
                        name: 'RecommendationLetter',
                        component: () =>
                            import (
                                `@/views/document/RecommendationLetter.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read recommendation-letter']

                        }
                    },
                    {
                        path: 'record',
                        name: 'DocumentRecord',
                        component: () =>
                            import (
                                `@/views/document/DocumentRecord.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read documents']

                        }
                    },
                    {
                        path: 'make-correction',
                        name: 'DocumentCorrection',
                        component: () =>
                            import (
                                `@/views/document/DocumentCorrection.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['make document-correction']

                        }
                    },

                ]
            },
            {
                path: 'overstay-application',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'OverstayApplication',
                    component: () =>
                        import (
                            `@/views/visa/OverstayApplication.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read overstay-application']
                    }
                },]
            },
            {
                path: 'visa-type-conditions',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: '/',
                        name: 'VisaTypeCondition',
                        component: () =>
                            import (
                                `@/views/visa/visa-type-condition/VisaConditionList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-condition']
                        }
                    },
                    {
                        path: 'create',
                        name: 'VisaTypeConditionCreate',
                        component: () =>
                            import (
                                `@/views/visa/visa-type-condition/VisaConditionForm.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-type-condition']
                        }
                    },
                    {
                        path: 'edit/:visa_type/:id',
                        name: 'VisaTypeConditionEdit',
                        component: () =>
                            import (
                                `@/views/visa/visa-type-condition/VisaConditionForm.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['view visa-type-condition']
                        }
                    },
                ]
            },
            {
                path: 'airline',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Airline',
                    component: () =>
                        import (
                            `@/views/airport-terminal/Airline.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read airline']
                    }
                },]
            },

            {
                path: 'flight-numbers',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'FlightNumber',
                    component: () =>
                        import (
                            `@/views/airport-terminal/FlightNumber.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read flight-numbers']
                    }
                },]
            },
            {
                path: 'blacklists',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Blacklist',
                    component: () =>
                        import (
                            `@/views/traveller/Blacklist.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read blacklist']
                    }
                },]
            },
            {
                path: 'interpol-check',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'InterpolCheck',
                    component: () =>
                        import (
                            `@/views/traveller/InterpolCheck.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read interpol-service']
                    }
                },]
            },
            {
                path: 'stickers',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Sticker',
                    component: () =>
                        import (
                            `@/views/visa-sticker/Sticker.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read sticker']
                    }
                },]
            },
            {
                path: 'blacklist-visa-stickers',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'BlacklistVisaSticker',
                    component: () =>
                        import (
                            `@/views/visa-sticker/BlacklistVisaSticker.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read blacklist-visa-sticker']
                    }
                },]
            },
            {
                path: 'watchlists',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'WatchList',
                    component: () =>
                        import (
                            `@/views/traveller/Watchlist.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read watchlist']
                    }
                },]
            },
            {
                path: 'airport',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Airport',
                    component: () =>
                        import (
                            `@/views/airport-terminal/Airport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read airport']
                    }
                },]
            },
            //Airport terminal related route
            {
                path: 'airport-terminal',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: 'group/',
                    name: 'TerminalGroup',
                    component: () =>
                        import (
                            `@/views/airport-terminal/TerminalGroup.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read terminal-group']
                    }
                },
                    {
                        path: 'group/:id',
                        name: 'TerminalGroupEdit',
                        component: () =>
                            import (`@/views/airport-terminal/group/Edit.vue`),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['view terminal-group-details']
                        }
                    },
                    {
                        path: 'shift/',
                        name: 'TerminalShift',
                        component: () =>
                            import (
                                `@/views/airport-terminal/TerminalShift.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read terminal-shift']
                        }
                    },
                    {
                        path: 'leave-history/',
                        name: 'LeaveHistory',
                        component: () =>
                            import (
                                `@/views/airport-terminal/Leave.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read terminal-shift']
                        }
                    }, {
                        path: 'desk/',
                        name: 'TerminalDesk',
                        component: () =>
                            import (
                                `@/views/airport-terminal/TerminalDesk.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read terminal-desk']
                        }
                    },
                    {
                        path: 'manage-schedule',
                        name: 'ManageSchedule',
                        component: () =>
                            import (
                                `@/views/airport-terminal/Schedule.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read manage-schedule']
                        }
                    },
                    {
                        path: 'fixed-user-desk',
                        name: 'TerminalFixedDeskUsers',
                        component: () =>
                            import (
                                `@/views/airport-terminal/TerminalFixedDeskUsers.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read terminal-fixed-user-desk']
                        }
                    },
                    {
                        path: 'terminal-group-shift',
                        name: 'TerminalGroupShift',
                        component: () =>
                            import (
                                `@/views/airport-terminal/TerminalGroupShift.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read terminal-group-shift']
                        }
                    },
                    {
                        path: 'extra-cell-phone',
                        name: 'ExtraCellPhone',
                        component: () => import (`@/views/airport-terminal/ExtraCellPhone.vue`),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read extra-cell-phone']
                        }
                    }

                ]
            },
            {
                path: 'fiscal-year',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'FiscalYear',
                    component: () =>
                        import (
                            `@/views/Fiscalyear.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read fiscal-year']
                    }
                },]
            },
            {
                path: 'stakeholder',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Stakeholder',
                    component: () =>
                        import (
                            `@/views/stakeholder/Stakeholder.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read stakeholder']
                    }
                },]
            },
            {
                path: 'stakeholder-api',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'StakeholderApi',
                    component: () =>
                        import (
                            `@/views/stakeholder/StakeholderApi.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read stakeholder-api']
                    }
                },]
            },
            {
                path: 'consular',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/diplomatic/visa/check',
                    name: 'ConsularVisaCheck',
                    component: () =>
                        import (
                            `@/views/stakeholder/ConsularCheck.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read consular-visa']
                    }
                },]
            },{
                path: 'consular',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/recommend/visa/check',
                    name: 'VisaRecommendationSearch',
                    component: () =>
                        import (
                            `@/views/stakeholder/VisaRecommendationCheck.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read consular-visa']
                    }
                },]
            },
            {
                path: 'cims',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/cims/citizenship',
                    name: 'CimsCitizenCheck',
                    component: () =>
                        import (
                            `@/views/stakeholder/CimsCitizenCheck.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read cims-citizenship-check']
                    }
                },]
            },
            {
                path: 'immi',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/check/self-declaration',
                    name: 'ImmiSelfDeclarationCheck',
                    component: () => import (`@/views/stakeholder/ImmiSelfDeclarationCheck.vue`),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read immi-self-declaration-check']
                    }
                }]
            },
            {
                path: 'dofe',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/passport/check',
                    name: 'DofePassportCheck',
                    component: () =>
                        import (
                            `@/views/stakeholder/DofeCheck.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read dofe-passport']
                    }
                },]
            },
            {
                path: 'sms',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: 'send',
                    name: 'SMSSend',
                    component: () =>
                        import (
                            `@/views/SmsSend.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['send sms']
                    }
                },]
            },
            {
                path: 'trekking-routes',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'TrekkingRoute',
                    component: () =>
                        import (
                            `@/views/trekking/TrekkingRoute.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read trekking-route']
                    }
                },]
            }, {
                path: 'trekking-agencies',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'TrekkingAgencies',
                    component: () =>
                        import (
                            `@/views/trekking/TrekkingAgencyList.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read trekking-agency']
                    }
                },
                    {

                        path: ':id',
                        name: 'ViewTrekkingAgency',
                        component: () =>
                            import (
                                `@/views/trekking/TrekkingAgencyView.vue`
                                ),

                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekking-agency']
                        }
                    },
                    {
                        path: ':id/edit',
                        name: 'TrekkingAgenciesEdit',
                        component: () =>
                            import (
                                `@/views/trekking/TrekkingAgencyEdit.vue`
                                ),

                        meta: {
                            requiresAuth: true,
                            checkPermission: ['alter trekking-agency']
                        }
                    },


                ]
            },
            {
                path: 'hotels',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Hotels',
                    component: () =>
                        import (
                            `@/views/hotel/HotelList.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read hotel']
                    }
                },


                    {
                        path: ':id',
                        name: 'HotelView',
                        component: () =>
                            import (
                                `@/views/hotel/HotelDetail.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read hotel']
                        }
                    },
                    {
                        path: ':id/edit',
                        name: 'HotelEdit',
                        component: () =>
                            import (
                                `@/views/hotel/HotelEdit.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['alter hotel']
                        }
                    },

                ]
            },
            {
                path: 'trekking-agency-users',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'TrekkingAgencyUsers',
                    component: () =>
                        import (
                            `@/views/trekking/TrekkingAgencyUser.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read trekking-agency-user']
                    }
                },]
            },
            {
                path: 'hotel-users',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'HotelUsers',
                    component: () =>
                        import (
                            `@/views/hotel/users/HotelUser.vue`
                            ),

                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read hotel-user']
                    }
                },]
            },
            {
                path: 'trekking-requests',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'TrekkingRequest',
                    component: () =>
                        import (
                            `@/views/trekking/trekking-request/TrekkingRequestList.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read trekking-request']
                    }
                },
                    {
                        path: 'new-trekking-request',
                        name: 'NewTrekkingRequest',
                        component: () =>
                            import (
                                `@/views/trekking/trekking-request/TrekkingRequestNew.vue`
                                ),

                        meta: {
                            requiresAuth: true,
                            checkPermission: ['add trekking-request']
                        }
                    },
                    {
                        path: 'new-trekking-request/confirm',
                        name: 'TrekkingRequestConfirm',
                        component: () =>
                            import (
                                `@/views/trekking/trekking-request/TrekkingRequestConfirm.vue`
                                ),

                        meta: {
                            requiresAuth: true,
                            checkPermission: ['add trekking-request']
                        }
                    },
                    {
                        path: 'view/:id',
                        name: 'ViewTrekkingRequest',
                        props: true,
                        component: () =>
                            import (
                                `@/views/trekking/trekking-request/TrekkingRequestView.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekking-request']
                        }
                    },
                ]
            },
            {
                path: 'single-trekking-requests',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'SingleTrekkingRequest',
                    component: () =>
                        import (
                            `@/views/trekking/single-trekking-request/TrekkingRequestList.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read trekking-request']
                    }
                },
                    {
                        path: 'view/:id',
                        name: 'ViewSingleTrekkingRequest',
                        props: true,
                        component: () =>
                            import (
                                `@/views/trekking/single-trekking-request/TrekkingRequestView.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read trekking-request']
                        }
                    }]
            },
            {
                path: 'visa-requests',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: 'bar-code',
                    name: 'BarCode',
                    component: () =>
                        import (
                            `@/views/visa/visa-request/BarCode.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read visa-request']
                    }
                },
                    {
                        path: 'pre-arrival-request',
                        name: 'PreArrivalVisaRequest',
                        component: () =>
                            import (
                                `@/views/visa/visa-request/PreArrivalVisaRequestList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-request']
                        }
                    }, {
                        path: 'request',
                        name: 'VisaRequest',
                        component: () =>
                            import (
                                `@/views/visa/visa-request/VisaRequestList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-request']
                        }
                    },
                    {
                        path: 'transfer',
                        name: 'VisaTransfer',
                        component: () =>
                            import (
                                `@/views/visa/visa-request/Transfer.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-transfer']
                        }
                    },
                    {
                        path: 'plan-upgrade',
                        name: 'VisaPlanUpgrade',
                        component: () =>
                            import (
                                `@/views/visa/plan/PlanUpgradeList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read plan-upgrade']
                        }
                    },
                    {
                        path: 'plan-upgrade/:id',
                        name: 'PlanUpgradeView',
                        component: () =>
                            import (
                                `@/views/visa/plan/PlanUpgradeView.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read plan-upgrade']
                        }
                    },
                    {
                        path: 'transfer-view/:id',
                        name: 'VisaTransferView',
                        component: () =>
                            import (
                                `@/views/visa/visa-request/VisaTransferView.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-transfer']
                        }
                    },
                    {
                        path: 'view/:id',
                        name: 'ViewVisaRequest',
                        props: true,
                        component: () =>
                            import (
                                `@/views/visa/visa-request/ViewVisaRequest.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read visa-request']
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'EditVisaRequest',
                        props: true,
                        component: () =>
                            import (
                                `@/views/visa/visa-request/EditVisaRequest.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['alter visa-request']
                        }
                    },
                    {
                        path: 'eta-request',
                        name: 'EtaVisaRequest',
                        component: () =>
                            import (
                                `@/views/visa/visa-request/EtaVisaRequestList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read eta-visa-request']
                        }
                    },

                ]
            },
            {
                path: 'certifications',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'arrival',
                        name: 'ArrivalCertification',
                        component: () =>
                            import (
                                `@/views/visa/certifications/CertificationRequestList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                    {
                        path: 'departure',
                        name: 'DepartureCertification',
                        component: () =>
                            import (
                                `@/views/visa/certifications/CertificationRequestList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                    {
                        path: 'without-visa-arrival',
                        name: 'NonVisaArrivalCertification',
                        component: () =>
                            import (
                                `@/views/visa/certifications/NonVisaCertificationList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                    {
                        path: 'without-visa-departure',
                        name: 'NonVisaDepartureCertification',
                        component: () =>
                            import (
                                `@/views/visa/certifications/NonVisaCertificationList.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                    {
                        path: 'non/:type/:id',
                        name: 'NonVisaCertificationView',
                        component: () =>
                            import (
                                `@/views/visa/certifications/NonVisaCertificationView.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                    {
                        path: ':type/:id',
                        name: 'CertificationView',
                        component: () =>
                            import (
                                `@/views/visa/certifications/CertificationRequestDetail.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read certification']
                        }
                    },
                ]
            },
            {
                path: 'manual-voucher-generation',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ManualVoucherGeneration',
                    component: () =>
                        import (
                            `@/views/ManualVoucherGeneration.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read manual-voucher-generation']
                    }
                }]
            },
            {
                path: 'manual-check-payment-status',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ManualCheckPaymentStatus',
                    component: () =>
                        import (
                            `@/views/ManualCheckPaymentStatus.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read manual-check-payment-status']
                    }
                }]
            },
            {
                path: 'previous-stay-check-status',
                name: 'PreviousStayCheckStatus',
                component: () =>
                    import (
                        `@/views/report/PreviousStayCheckStatus.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['read manual-check-payment-status']
                }
            },
            {
                path: 'service-provider',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ServiceProvider',
                    component: () =>
                        import (
                            `@/views/ServiceProvider.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read service-provider']
                    }
                },
                    {

                        path: ':id',
                        name: 'ViewServiceProvider',
                        component: () =>
                            import (
                                `@/views/ServiceProviderView.vue`
                                ),

                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read service-provider']
                        }
                    },
                ]
            },
            {
                path: 'service-provider-type',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ServiceProviderType',
                    component: () =>
                        import (
                            `@/views/ServiceProviderType.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read service-provider-type']
                    }
                }]
            },
            {
                path: 'service-provider-type-purpose',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ServiceProviderTypePurpose.vue',
                    component: () =>
                        import (
                            `@/views/ServiceProviderTypePurpose.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read service-provider-type-purpose']
                    }
                }]
            },
            {
                path: 'service-provider-report',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'ServiceProviderReport.vue',
                    component: () =>
                        import (
                            `@/views/ServiceProviderReport.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read service-provider']
                    }
                }]
            },
            {
                path: 'sliders',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Slider',
                    component: () =>
                        import (
                            `@/views/Slider.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read slider']
                    }
                }]
            },
            {
                path: 'notice',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: '/',
                        name: 'Notice',
                        component: () =>
                            import (
                                `@/views/Notice.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read notice']
                        }
                    }]
            },

            {
                path: 'noc-check',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'NocCheck',
                    component: () =>
                        import (
                            `@/views/stakeholder/NocCheck.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read noc-number']
                    }
                }]
            },
            {
                path: 'support-tickets',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'SupportTickets',
                    component: () =>
                        import (
                            `@/views/SupportTickets.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read support-ticket']
                    }
                }]
            },
            {
                path: 'visa/entry',
                name: 'VisaEntry',
                component: () =>
                    import (
                        `@/views/visa/new_entry/New.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['add visa-record']
                }
            },

            {
                path: 'visa/entry/confirm',
                name: 'VisaEntryConfirm',
                component: () =>
                    import (
                        `@/views/visa/new_entry/Confirm.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['add visa-record']
                }
            },
            {
                path: 'traveller/info-change',
                name: 'TravellerUpdate',
                component: () =>
                    import (
                        `@/views/visa/new_entry/Traveller.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['alter traveller-record']
                }
            },

            {
                path: 'offices',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'Office',
                    component: () =>
                        import (
                            `@/views/Office.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read office']
                    }
                }]
            },
            {
                path: 'access-ip',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'AccessIp',
                    component: () =>
                        import (
                            `@/views/AccessIp.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read access-ip']
                    }
                }]
            },

            {
                path: 'address',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: 'state',
                    name: 'State',
                    component: () =>
                        import (
                            `@/views/address/State.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read state']
                    }
                },
                    {
                        path: 'district',
                        name: 'District',
                        component: () =>
                            import (
                                `@/views/address/District.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read district']
                        }
                    },
                    {
                        path: 'municipality',
                        name: 'City',
                        component: () =>
                            import (
                                `@/views/address/City.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read city']
                        }
                    },


                ]
            },

            {
                path: '/dynamic-values-setup',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [
                    {
                        path: 'user-section',
                        name: 'UserSection',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read user-department']
                        }
                    },
                    {
                        path: 'user-designation',
                        name: 'UserDesignation',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read user-designation']
                        }
                    },
                    {
                        path: 'purpose-of-visa',
                        name: 'PurposeOfVisa',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'purpose-of-arrival',
                        name: 'PurposeOfArrival',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'purpose-of-departure',
                        name: 'PurposeOfDeparture',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'relations',
                        name: 'Relations',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'occupations',
                        name: 'Occupations',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'blacklists-reason',
                        name: 'BlackListReason',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'reason-for-conversion',
                        name: 'ReasonForConversion',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'reason-for-extension',
                        name: 'ReasonForExtension',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'reason-for-certification',
                        name: 'ReasonForCertification',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'reason-for-transfer',
                        name: 'ReasonForTransfer',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'muddha-category',
                        name: 'MuddhaCategory',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read muddha-category']
                        }
                    },
                    {
                        path: 'visa-application-mail',
                        name: 'VisaApplicationMail',
                        component: () =>
                            import (
                                `@/views/visa/ApplicationMail.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'document-category',
                        name: 'documentCategory',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'blacklist-visa-sticker-reasons',
                        name: 'ReasonForVisaStickerBlacklist',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'desk-groups',
                        name: 'DeskGroup',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'colleges',
                        name: 'College',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'companies',
                        name: 'Company',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                    {
                        path: 'trekking-agency',
                        name: 'trekkingAgancy',
                        component: () =>
                            import (
                                `@/views/dynamic-values/DynamicValues.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read dynamic-values-setup']
                        }
                    },
                ]
            },
            {
                path: 'special-case-payment',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'SCPList',
                    component: () =>
                        import (
                            `@/views/traveller/SCPList.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read special-case-payment']
                    }
                },
                    {
                        path: 'view/:id',
                        name: 'ViewSCPDetail',
                        props: true,
                        component: () =>
                            import (
                                `@/views/traveller/ViewSCPDetail.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            checkPermission: ['read special-case-payment']
                        }
                    }]
            },
            {
                path: 'domestic-flight',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'DomesticFlight',
                    component: () =>
                        import (
                            `@/views/domestic-flight/DomesticFlightCheck.vue`
                            ),
                    meta: {
                        requiresAuth: true,
                        checkPermission: ['read interpol-service']
                    }
                },]
            },
            {
                path: 'eta/dashboard',
                component: () =>
                    import (
                        `@/views/EtaDashboard.vue`
                        ),
                meta: {
                    requiresAuth: true,
                    checkPermission: ['read eta-dashboard']
                },
                name: 'EtaDashboard'
            },
            {
                path: 'dynamic-routes',
                meta: {
                    requiresAuth: true,
                },
                component: commonLayout(),
                children: [
                    {
                        path: '/',
                        name: 'DynamicRoutes',
                        component: () =>
                            import (
                                `@/views/dynamic-routes/ListDynamicRoutes.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                        },
                    },
                    {
                        path: 'create',
                        name: 'CreateDynamicRoute',
                        component: () =>
                            import (
                                `@/views/dynamic-routes/CreateDynamicRoute.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            // checkPermission: ['read special-case-payment']
                        },
                    },
                    {
                        path: 'edit/:id',
                        name: 'EditDynamicRoute',
                        component: () =>
                            import (
                                `@/views/dynamic-routes/EditDynamicRoute.vue`
                                ),
                        meta: {
                            requiresAuth: true,
                            // checkPermission: ['read special-case-payment']
                        },
                    },
                ],
            },
        ]
    }
]
